import styled from 'styled-components';
import React, {useState, useEffect} from 'react';
import AnchorLink from "react-anchor-link-smooth-scroll";

// import TopBackgroundVideo from '../../assets/video/top_background.mov'
import HeaderLogo from '../../assets/image/icon/header_logo.png';
import TopLogo from '../../assets/image/icon/top_logo.png'
import InstagramIcon from '../../assets/image/icon/instagram.png';
import TiktokIcon from '../../assets/image/icon/tiktok.png';
import TwitterIcon from '../../assets/image/icon/twitter.png';
import TopBackgroundImage from '../../assets/image/brand_story/top_background.png';

const TopSection = styled.section`
  header {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 550px;
    height: 6vh;
    z-index: 11;
    img {
      width: 160px;
      z-index: 11;
    }
  }

  .top-container {
    height: 100vh;
    width: 100%;
    position: relative;
    // overflow-x: hidden;

    // video {
    //   width: 100%;
    //   height: 100vh;
    //   object-fit: cover;
    //   filter: brightness(0.8);
    //   animation: fadeIn 3s ease;
    // }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    img:first-child {
      width: 70%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    img:last-child {
      width: 100%;
      height: 100vh;
      object-fit: cover;
      filter: brightness(0.8);
    }
  }

  .openbtn{
    position: fixed;
    cursor: pointer;
    width: 50px;
    height:50px;
    border-radius: 5px;
    z-index: 12;
    margin: 3px 0 0 5px;
  }

  .openbtn span{
    display: inline-block;
    transition: all .4s;
    position: absolute;
    left: 14px;
    height: 1px;
    border-radius: 2px;
    background: #000;
    width: 45%;
  }

  .openbtn span:nth-of-type(1) {
    top:15px; 
  }

  .openbtn span:nth-of-type(2) {
    top:23px;
  }

  .openbtn span:nth-of-type(3) {
    top:31px;
  }

  .openbtn.is-open span:nth-of-type(1) {
    top: 18px;
    left: 18px;
    transform: translateY(6px) rotate(-45deg);
    width: 40%;
  }

  .openbtn.is-open span:nth-of-type(2) {
    opacity: 0;
  }

  .openbtn.is-open span:nth-of-type(3){
    top: 30px;
    left: 18px;
    transform: translateY(-6px) rotate(45deg);
    width: 40%;
  }
`

const SectionTop = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      // メニューが開いたら縦スクロールを制御するための処理
      document.body.classList.add('no-scroll');
    } else {
      // メニューが閉じたら縦スクロール制御を解除するための処理
      document.body.classList.remove('no-scroll');
    }
  }, [isOpen]);

  const handleClick = () => {
    setIsOpen(!isOpen);
  }

  return (
    <TopSection>
      <header>
        <img src={HeaderLogo} alt="PLACOLE & DRESSY"/>
        {isOpen && (
          <HamburgerMenu onClick={() => handleClick()} />
        )}
      </header>
      <div className={`openbtn ${isOpen ? 'is-open' : ''}`} onClick={handleClick}>
        <span></span><span></span><span></span>
      </div>
      {/* <div className='top-container'>
        <img src={TopLogo} alt="PLACOLE & DRESSY" />
        <img src={TopBackgroundImage} alt="PLACOLE & DRESSY" />
        <div className="video-player">
          <video autoPlay loop muted playsInline className="video">
            <source src={TopBackgroundVideo} type="video/mp4" />
          </video>
        </div>
      </div> */}
    </TopSection>
  )
}

export default SectionTop;

const HamburgerMenuSection = styled.section`
  position: absolute;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100vh;
  z-index: 10;
  max-width: 550px;
  animation: fade-in 0.5s ease;

  @keyframes fade-in {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .menu-button-wrapper {
    margin-top: 25%;
    padding: 0 10%;

    a {
      text-decoration: none;
      color: black;
      padding: 10px 0;
      font-weight: 500;
      margin: 10px 0;
      display: block;
    }
  }

  .sns-button-wrapper {
    margin-top: 60px;

    ul {
      display: flex;
      justify-content: space-between;
      width: 50%;
      margin: 0 auto;
    }

    a {
      display: flex;
      justify-content: center;
    }

    img {
      width: 70%;
    }
  }
`


const HamburgerMenu = (props) => {
  return (
    <HamburgerMenuSection isOpen={props.isOpen}>
      <nav>
        <ul className="menu-button-wrapper">
          <AnchorLink href="#brand-story" onClick={props.onClick}>ブランドストーリー</AnchorLink>
          <AnchorLink href="#collaboration-dress" onClick={props.onClick}>コラボドレス</AnchorLink>
          <AnchorLink href="#original-dress" onClick={props.onClick}>オリジナルドレス</AnchorLink>
          <AnchorLink href="#collaboration-accessory" onClick={props.onClick}>コラボリング・アクセサリー</AnchorLink>
          <AnchorLink href="#life-style-item" onClick={props.onClick}>ライフスタイルアイテム</AnchorLink>
          <AnchorLink href="#shop-list" onClick={props.onClick}>ショップリスト</AnchorLink>
          <AnchorLink href="#produce-cafe" onClick={props.onClick}>プロデュースカフェ</AnchorLink>
        </ul>
      </nav>
      <div className="sns-button-wrapper">
        <ul>
          <li><a target="_blank" href="https://instagram.com/placole_dressy" rel="noopener noreferrer"><img src={InstagramIcon} alt="Instagram" /></a></li>
          <li><a target="_blank" href="https://www.tiktok.com/@placole_dressy" rel="noopener noreferrer"><img src={TiktokIcon} alt="TikTok" /></a></li>
          <li><a target="_blank" href="https://twitter.com/placole_dressy" rel="noopener noreferrer"><img src={TwitterIcon} alt="Twitter" /></a></li>
        </ul>
      </div>
    </HamburgerMenuSection>
  )
}